export const languages = {
  curl: 'cURL',
  node: 'Node.js',
  python: 'Python',
  php: 'PHP',
  ruby: 'Ruby',
  go: 'Go'
};

export const defaultLanguage = 'curl';

export const languagesList = Object.entries(languages).map(([key, value]) => ({
  key,
  label: value
}));